import {BookingStatusNames} from "app/bookingStatusTypes";
import {BookingType} from "app/app.types";
import {StatusService} from 'external-services/status-service';
import ObjectCopyService from "external-services/object-copy-service/index";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import BookingUpdateService from "external-services/booking-update-service/index";
import BookingLockService from 'external-services/booking-lock-service'
import {BookingCancelledReason, BookingMethods, UnreliableBookingStatusIds} from "shared-types/index";
import store from "appRoot/Store";
import StatusConfigService from "external-services/status-config-service";

const NS = 'StatusEditor';

// requiring html templates so that hot reloading works
const template = require('./statusEditorInline.html');

export default function StatusEditor() {
  return {
    replace: true,
    bindToController: true,
    controllerAs: 'vm',
    template,
    restrict: 'E',
    scope: {
      booking: '=',
      open: '=',
      schedule: '=',
      closeFunc: '='
    },
    controller
  }
}

// just exported for unit tests
export function controller($timeout, $mdDialog, $mdToast) {
  "ngInject";

  var vm = this;
  // define public methods
  vm.changeStatus = changeStatus;
  vm.close = close;

  const venue = AdminService.getVenue();
  const isStandbyListEnabled = venue.standByList || false;


  this.$onInit = function () {
    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    vm.statusOptions = statusOptions.filter(status => {
      return StatusService.statusSelectFilter('', status.name, vm.booking.bookingType, vm.booking.paymentDetails);
    });

    // check couch url/name still correct
    AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
    AdminService.loadVenue(venue.id, true, true).catch(function (err) {
      console.error(err);
    });
  };

  function close() {
    vm.open = false;
    vm.closeFunc();
  }

  function changeStatus(status, message) {
    GeneralSettingsService.get().then(function (settings) {
      const isOldEditSettings = settings.staffEditEnabled && !settings.staffEdit;
      const isNewEditSettings = settings.staffEdit && settings.staffEdit.staffEditQuickEdit;
      const notSeated = status._id !== UnreliableBookingStatusIds.StatusSeated;
      if ((isOldEditSettings || isNewEditSettings) && settings.staffEditEnabled && notSeated && vm.booking.method !== BookingMethods.walkin) {
        close();
        var staffNameDialog = $mdDialog.prompt()
          .title('Booking change')
          .placeholder('Staff name')
          .ariaLabel('Staff name')
          .ok('Confirm')
          .cancel('Cancel')
          .clickOutsideToClose(true);

        if (message) {
          staffNameDialog.textContent(message);
        }

        $mdDialog.show(staffNameDialog).then(function (staff) {
          // required check is here because AngularJS Material 1.0.7 doesn't have a 'required' stetting for prompt dialogs
          if (settings.staffEditRequired && !staff) {
            changeStatus(status, 'Staff name required');
          } else {
            update(status, staff);
          }
        });
      } else {
        update(status);
      }
    });
  }

  function update(status, staff) {

    if (AdminService.isPartnerBookingsLocked(vm.booking?.partner) === true) {
      $mdToast.show(
        $mdToast.simple()
          .content('Booking is locked. Please make changes in Function Tracker.')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );
    }
    else {
      let paymentLock = BookingLockService.isBookingLockedBy(BookingLockService.PaymentPendingLockName, vm.booking);
      let isLockedForView = false;
      let lockedMessage = '';
      if (paymentLock) { //If this is true the booking supports the new locking mechanism
        lockedMessage = paymentLock.reason; //Use the server provided reason.
        isLockedForView = true;
      } else {
        //Apply legacy locking until deprecated, why is this logic different than all the others? Leaving it for now.
        const hasPaymentPending = vm.booking.status.name === BookingStatusNames.PendingPayment;
        isLockedForView = vm.booking.method == "online" && hasPaymentPending && !vm.booking.movedFromBookingId;
      }

      if (isLockedForView) { // @todo: write tests for this. severity: high
        // Do nothing please ($scope.info.method == "online"
        $mdToast.show(
          $mdToast.simple()
            .content(lockedMessage)
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );
      } else {
        // continue with updates
        var orgBooking = ObjectCopyService.angularSafeCopy(vm.booking);
        vm.booking.isSaving = true;
        vm.booking.status = status;
        vm.booking.statusForRevertFinishAll = undefined;

        //If booking is being edited, reset cancel reason to default.
        vm.booking.cancelledReason = BookingCancelledReason.unspecified;

        // if manually changed to confirmed or seated, then we force it to a normal bookingType
        if (status.name === BookingStatusNames.Confirmed || status.name === BookingStatusNames.Seated) {
          vm.booking.bookingType = vm.booking.bookingType === BookingType.StandbyList ? BookingType.WaitList : BookingType.Booking;
        }
        else if (vm.booking.bookingType == BookingType.StandbyList && status.name === BookingStatusNames.Unconfirmed) {
          vm.booking.tables = [];
        }

        vm.booking = BookingUpdateService.updateAfterStatusChange(vm.booking, orgBooking);
        BookingUpdateService.updateFromAnywhere(vm.booking, orgBooking, null, null, staff).then(function () {
          $timeout(function () {
            delete vm.booking.isSaving;
          }, 1000);
          close();
        });
      }
    }
  }
}
